import { useTranslate } from '@refinedev/core';
import { Card, theme } from 'antd';
import { MobilePreviewProvider } from '@/components/mobile_preview/MobilePreviewProvider';
import { MobileThemeSegmented } from '@/components/mobile_preview/MobileThemeSegmented';
import { PhoneFrame } from '@/components/mobile_preview/PhoneFrame';
import { MobilePreviewDisclaimer } from '@/components/mobile_preview/MobilePreviewDisclaimer';
import { HomePreviewHeroSection } from './HomePreviewHero';
import { HomePreviewShelves } from './HomePreviewShelves';
import type { HomePreviewModel } from './homePreviewModel';

interface HomePreviewProps {
  model: HomePreviewModel;
}

/** Phone-frame replica of the app's home feed. Mounted beside the tabs,
 * outside them, so switching tabs never remounts it. */
export const HomePreview = ({ model }: HomePreviewProps) => {
  const t = useTranslate();
  const { token } = theme.useToken();

  return (
    // The provider wraps the card, not the frame: the theme control lives in
    // the header and reads the same context the phone does.
    <MobilePreviewProvider>
      <Card
        size="small"
        title={t('user_catalog.home_page.preview.title')}
        extra={<MobileThemeSegmented />}
        styles={{ body: { padding: token.paddingSM } }}
      >
        {/* Backdrop panel — the phone reads as a device sitting on a surface
            rather than as another card section. */}
        <div
          style={{
            background: token.colorFillQuaternary,
            borderRadius: token.borderRadiusLG,
            padding: token.paddingSM,
          }}
        >
          <PhoneFrame>
            <HomePreviewHeroSection hero={model.hero} />
            <HomePreviewShelves sections={model.sections} />
          </PhoneFrame>
        </div>

        <MobilePreviewDisclaimer />
      </Card>
    </MobilePreviewProvider>
  );
};
